module.exports = __webpack_public_path__ + "static/media/banner_5.b0c0eca8.jpg";